import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Form, {
  ButtonItem,
  SimpleItem,
  GroupItem,
  Label,
  TabbedItem,
  TabPanelOptions,
  Tab,
  RequiredRule,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import "devextreme-react/html-editor";
import notify from "devextreme/ui/notify";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { loadMessages, formatMessage, locale } from "devextreme/localization";
import dictionary from "../../data/dictionary";
import useJSON from "../../hook/useJSON";
import MenuItemsList from "../../components/website/MenuItemsList";
import { MENU_POSITION, WEBSITE_URL } from "../../utils/constants";

loadMessages(dictionary);

const parseJSON = (str, languageId) => {
  let _strObj;
  try {
    _strObj = JSON.parse(str);
  } catch (e) {
    return str || "";
  }
  return _strObj ? _strObj[languageId] || "" : "";
};

const tabsMock = [
  {
    id: 0,
    text: "vi-VN",
    icon: "globe",
    content: "Vietnamese",
  },
];

const MenuVM = (data, languages) => {
  const returnData = useJSON(data, languages);

  return returnData;
};

const MenuMV = (data, languages) => {
  const nameObj = {};
  const descriptionObj = {};
  languages.forEach((language) => {
    nameObj[[language.languageId]] = data[`name-${language.languageId}`];
    descriptionObj[[language.languageId]] =
      data[`description-${language.languageId}`];
  });

  return JSON.stringify({
    name: JSON.stringify(nameObj),
    description: JSON.stringify(descriptionObj),
    order: data.order,
    isActive: data.isActive,
    position: data.position,
    concurrencyStamp: data.concurrencyStamp,
  });
};

const PositionVM = (data, currentLanguage) => {
  return {
    id: data.id,
    name: parseJSON(data.name, currentLanguage),
  };
};

const MenuDetailContainer = ({
  accessToken,
  currentLanguage,
  currentWebsite,
  websiteLanguages,
}) => {
  locale(currentLanguage.substring(0, 2));
  const history = useHistory();
  const params = useParams();
  const [menu, setMenu] = useState({});
  const [tabs, setTabs] = useState(tabsMock);

  useEffect(() => {
    const _tabs = websiteLanguages.map((item, index) => ({
      id: index,
      languageId: item.languageId,
      text: item.name,
      icon: "globe",
      content: "User tab content",
    }));
    setTabs(_tabs);
  }, [websiteLanguages]);

  useEffect(() => {
    if (!currentWebsite || !params.menuId) {
      return;
    }
    fetch(`${WEBSITE_URL}Menus/${currentWebsite}/${params.menuId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Access-Control-Allow-Origin": "*",
      },
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            setMenu(MenuVM(json.data, websiteLanguages));
            return;
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  }, [currentWebsite, websiteLanguages, accessToken, params.menuId, history]);

  const updateMenu = () => {
    fetch(`${WEBSITE_URL}Menus/${currentWebsite}/${menu.id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
      body: MenuMV(menu, websiteLanguages),
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            history.push("/menu");
            notify(
              {
                message: json.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "success",
              3000
            );
            return;
          }
          throw json.Message;
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  };

  const addMenu = () => {
    fetch(`${WEBSITE_URL}Menus/${currentWebsite}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": currentLanguage,
      },
      body: MenuMV(menu, websiteLanguages),
    }).then((result) =>
      result
        .json()
        .then((json) => {
          if (result.ok) {
            history.push("/menu");
            notify(
              {
                message: json.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "success",
              3000
            );
          } else {
            notify(
              {
                message: json.message,
                position: {
                  my: "center top",
                  at: "center top",
                },
              },
              "error",
              3000
            );
          }
        })
        .catch(() => {
          if (result.status === 401) {
            history.push("/login");
          }
        })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (params.menuId) {
      updateMenu(false);
    } else {
      addMenu(false);
    }
  };

  const saveButtonOptions = {
    text: formatMessage("save"),
    icon: "save",
    type: "default",
    stylingMode: "contained",
    useSubmitBehavior: true,
  };

  const backButtonOptions = {
    type: "back",
    onClick: () => {
      history.push("/menu");
    },
  };

  const menuPositionsSelectOptions = {
    items: MENU_POSITION.map((type) => PositionVM(type, currentLanguage)),
    displayExpr: "name",
    searchEnabled: true,
    valueExpr: "id",
  };

  return (
    <React.Fragment>
      <Toolbar>
        <Item location="before" widget="dxButton" options={backButtonOptions} />
        <Item
          location="center"
          text={`${formatMessage("info")} ${formatMessage(
            "of"
          )} ${formatMessage("menu")}`}
        />
      </Toolbar>
      <form action="your-action" onSubmit={handleSubmit}>
        <Form
          formData={menu}
          readOnly={false}
          showColonAfterLabel={true}
          colCount={2}
          showValidationSummary={true}
        >
          <GroupItem caption="Đa ngôn ngữ">
            <TabbedItem>
              <TabPanelOptions deferRendering={false} />
              {tabs.map((item) => {
                return (
                  <Tab key={item.id} title={item.text} icon={item.icon}>
                    <SimpleItem
                      dataField={`name-${item.languageId}`}
                      editorType="dxTextBox"
                    >
                      <Label text={formatMessage("name")} />
                      <RequiredRule
                        message={`${formatMessage("name")} ${formatMessage(
                          item.languageId
                        )} ${formatMessage("errMesRequire")}`}
                      />
                    </SimpleItem>
                    <SimpleItem
                      dataField={`description-${item.languageId}`}
                      editorType="dxTextArea"
                    >
                      <Label text={formatMessage("description")} />
                    </SimpleItem>
                  </Tab>
                );
              })}
            </TabbedItem>
          </GroupItem>

          <GroupItem caption="Nội dung khác" colCount={2}>
            <SimpleItem
              dataField="position"
              editorType="dxSelectBox"
              editorOptions={menuPositionsSelectOptions}
              colSpan={2}
            >
              <Label text={formatMessage("position")} />
              <RequiredRule
                message={`${formatMessage("position")} ${formatMessage(
                  "errMesRequire"
                )}`}
              />
            </SimpleItem>
            <SimpleItem dataField={"order"} editorType="dxNumberBox">
              <Label text={formatMessage("order")} />
            </SimpleItem>
            <SimpleItem dataField={"isActive"} editorType="dxCheckBox">
              <Label text={formatMessage("isActive")} />
            </SimpleItem>
          </GroupItem>

          <ButtonItem
            horizontalAlignment="center"
            colSpan={2}
            buttonOptions={saveButtonOptions}
          />
        </Form>
      </form>

      <hr />
      {menu.id && (
        <MenuItemsList
          menuId={menu.id}
          items={menu.menuItems}
          currentWebsite={currentWebsite}
          currentLanguage={currentLanguage}
          accessToken={accessToken}
          languages={websiteLanguages}
        />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.data.token,
    currentLanguage: state.setting.currentLanguage,
    languages: state.setting.languages,
    websiteLanguages: state.setting.languages,
    currentWebsite: state.website.data.currentWebsite,
  };
};

MenuDetailContainer.propTypes = {
  accessToken: PropTypes.string,
  languages: PropTypes.array,
  currentLanguage: PropTypes.string,
  websiteId: PropTypes.string,
  websiteLanguages: PropTypes.array,
  currentWebsite: PropTypes.string,
};

export default connect(mapStateToProps, null)(MenuDetailContainer);
